export default __webpack_public_path__ + "static/media/renaldo_andrews_feature.262e5967.jpeg";